<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width product-select"
               :value="value"
               :value-key="valueKey ? valueKey :'product_id'"
               @change="onChange"
               :placeholder="$t('generic.select')"
               v-bind="$attrs">
      <el-option v-for="option in options"
                 class="select-default"
                 :key="option.product_id"
                 :label="option.name"
                 :value="valueKey ? option[valueKey] : option">
        <div class="d-flex justify-content-between align-items-center">
          <span class="d-flex align-items-center">
            <span v-html="option.name"></span>&nbsp;
            <span v-if="option.job_days">({{option.job_days}} {{$t('generic.days')}})</span>&nbsp;
            &nbsp;
            <status-badge v-if="option.featured_job === 1" class="mb-0">{{$t('generic.premium')}}</status-badge>
          </span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'

  export default {
    name: 'product-select',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      options: {
        type: Array,
        default: () => []
      },
      value: {
        type: [String, Number, Object],
        default: 1
      },
      label: {
        type: String
      },
      valueKey: {
        type: String,
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      }
    }
  }
</script>
<style lang="scss">
  .product-select {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
